import { getStoreConfig } from 'config'
import { getInitScriptContent } from './getInitScriptContent'

export type GtmBootstrap = {
    isEnabled: boolean
    containerId: string
    initScript: string
    noScript: string
}

/**
 * Resuelve si GTM debe bootstrappearse y el contenido de los snippets.
 * Usable desde `_document` (sin hooks) para instalar el contenedor lo más alto posible.
 *
 * En development se desactiva por defecto (ruido de tags de terceros en consola);
 * forzá con NEXT_PUBLIC_ENABLE_GTM_IN_DEV=true.
 */
export const resolveGtmBootstrap = (locale?: string): GtmBootstrap => {
    const gtm = getStoreConfig(locale)?.seo?.tagManager?.gtm
    const forceGtmInDev = process.env.NEXT_PUBLIC_ENABLE_GTM_IN_DEV === 'true'
    const isDev = process.env.NODE_ENV === 'development'
    const containerId =
        Boolean(gtm?.enabled) &&
        Boolean(gtm?.containerId) &&
        (!isDev || forceGtmInDev)
            ? String(gtm?.containerId)
            : ''
    const isEnabled = Boolean(containerId)
    const { initScript, noScript } = getInitScriptContent(containerId)

    return {
        isEnabled,
        containerId,
        initScript: isEnabled ? initScript : '',
        noScript: isEnabled ? noScript : ''
    }
}

export default resolveGtmBootstrap
